<template>

  <transition name="drawer">

    <div
        v-if="open"
        class="drawer-wrapper"
    >

      <div
          class="overlay"
          @click="$emit('close')"
      />

      <aside class="drawer">

        <div class="drawer-header">

          <img
              src="@/assets/images/logo.png"
              class="logo"
              alt="ضربه آزاد"
          >

          <button
              type="button"
              aria-label="بستن منو"
              @click="$emit('close')"
          >
            ×
          </button>

        </div>

        <nav>

          <router-link
              @click.native="$emit('close')"
              to="/"
          >
            🏠 خانه
          </router-link>

          <router-link
              @click.native="$emit('close')"
              to="/news"
          >
            📰 اخبار
          </router-link>

          <router-link
              @click.native="$emit('close')"
              to="/matches"
          >
            ⚽ مسابقات
          </router-link>

          <router-link
              @click.native="$emit('close')"
              to="/fifa-day"
          >
            🌍 فیفا دی
          </router-link>

          <router-link
              @click.native="$emit('close')"
              to="/special"
          >
            ⭐ ویژه
          </router-link>

          <router-link
              @click.native="$emit('close')"
              to="/competition"
          >
            🏆 لیگ‌ها
          </router-link>

          <router-link
              @click.native="$emit('close')"
              to="/teams"
          >
            🛡 تیم‌ها
          </router-link>

          <router-link
              @click.native="$emit('close')"
              to="/standings"
          >
            📊 جدول
          </router-link>

        </nav>

      </aside>

    </div>

  </transition>

</template>

<script>

export default {

  name: "MobileDrawer",

  props: {
    open: {
      type: Boolean,
      default: true
    }
  }

}

</script>

<style scoped lang="scss">

.drawer-wrapper {

  position: fixed;

  inset: 0;

  z-index: 9999;
}

.overlay {

  position: absolute;

  inset: 0;

  background: rgba(0, 0, 0, .55);
}

.drawer {

  position: absolute;

  top: 0;
  right: 0;

  width: min(82vw, 300px);

  height: 100%;

  background: #081c15;

  color: #fff;

  display: flex;

  flex-direction: column;

  box-shadow: -10px 0 30px rgba(0, 0, 0, .2);
}

.drawer-header {

  display: flex;

  justify-content: space-between;

  align-items: center;

  padding: 18px;

  border-bottom: 1px solid rgba(255,255,255,.1);
}

.logo {

  width: 130px;

  height: auto;
}

button {

  width: 42px;
  height: 42px;

  display: flex;

  align-items: center;
  justify-content: center;

  background: rgba(255,255,255,.08);

  border: none;

  border-radius: 10px;

  color: #fff;

  font-size: 28px;

  cursor: pointer;
}

nav {

  display: flex;

  flex-direction: column;

  padding-top: 8px;
}

nav a {

  padding: 17px 22px;

  color: #fff;

  text-decoration: none;

  border-bottom: 1px solid rgba(255,255,255,.07);

  font-size: 15px;
}

nav a:active,
nav a:hover,
.router-link-exact-active {

  color: #42d392;

  background: rgba(66,211,146,.07);
}

.drawer-enter-active,
.drawer-leave-active {

  transition: .3s ease;
}

.drawer-enter-from .drawer,
.drawer-leave-to .drawer {

  transform: translateX(100%);
}

.drawer-enter-active .drawer,
.drawer-leave-active .drawer {

  transition: transform .3s ease;
}

.drawer-enter-active .overlay,
.drawer-leave-active .overlay {

  transition: opacity .3s ease;
}

.drawer-enter-from .overlay,
.drawer-leave-to .overlay {

  opacity: 0;
}

</style>